import { render, staticRenderFns } from "./applyPerson.vue?vue&type=template&id=48e395fb&"
import script from "./applyPerson.vue?vue&type=script&lang=js&"
export * from "./applyPerson.vue?vue&type=script&lang=js&"
import style0 from "./applyPerson.vue?vue&type=style&index=0&id=48e395fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports